import { render, staticRenderFns } from "./PaymentRegisterCard.vue?vue&type=template&id=667cee27&"
import script from "./PaymentRegisterCard.vue?vue&type=script&lang=js&"
export * from "./PaymentRegisterCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports